import {
  LOAD_MASTERDATA_USER,
  CREATE_MASTERDATA_USER,
  LOAD_DETAILMASTERDATA_USER,
  LOAD_DETAILMASTERDATA_FOR_EDIT,
  UPDATE_MASTERDATA_USER,
  REMOVE_LISTS,
} from "./actions";

const initialState = {
  lists: [],
  total: 1,
  loading: false,
  detailMasterDataUserloading: false,
  loadDetailMasterDataForEdit: false,
  loadDetailPermissionForEdit: false,
  check: true,
  check1: true,
  draw: -1,
  create_status: null,
  update_status: null,
  error_msg: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState;

    case LOAD_MASTERDATA_USER.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        loading: loading,
        check: true,
      };

    case LOAD_MASTERDATA_USER.SUCCESS:
      return {
        ...state,
        lists: action.payload.lists.data,
        check: false,
        total: action.payload.lists.total_rows,
        loading: false,
      };

    case LOAD_DETAILMASTERDATA_USER.REQUEST:
      const { detailMasterDataUserloading } = action.payload;
      return {
        ...state,
        detailMasterDataUserloading: detailMasterDataUserloading,
        check: true,
        loading: true,
      };

    case LOAD_DETAILMASTERDATA_USER.SUCCESS:
      return {
        ...state,
        lists: action.payload.lists.data,
        check: false,
        loading: false,
      };

    case CREATE_MASTERDATA_USER.REQUEST:
    case UPDATE_MASTERDATA_USER.REQUEST:
      return {
        ...state,
        check: false,
        loading: false,
        error_msg: "",
      };

    case CREATE_MASTERDATA_USER.SUCCESS:
      const { res } = action.payload;
      return {
        ...state,
        loading: false,
        create_status: res.email,
      };

    case LOAD_DETAILMASTERDATA_FOR_EDIT.REQUEST:
      const { loadDetailMasterDataForEdit } = action.payload;
      return {
        ...state,
        loading: true,
        loadDetailMasterDataForEdit: loadDetailMasterDataForEdit,
      };

    case LOAD_DETAILMASTERDATA_FOR_EDIT.SUCCESS:
      return {
        lists: action.payload.lists,
        loadDetailMasterDataForEdit: false,
        error_msg: "",
        loading: false,
        check1: false,
      };

    case UPDATE_MASTERDATA_USER.SUCCESS:
      return {
        ...state,
        loading: false,
        update_status: action.payload.res.email,
      };

    case UPDATE_MASTERDATA_USER.FAILURE:
    case CREATE_MASTERDATA_USER.FAILURE:
      return {
        ...state,
        loading: false,
        error_msg: action.payload.error,
      };

    default:
      return state;
  }
};
